export function fixNumbers(value: number | string) {
  if (Number(value)) {
    return String((Math.round(Number(value) * 100) / 100).toFixed(2));
  }

  return value;
}

export function getValidNumber(
  value: number | string | boolean | null | undefined
): number | undefined {
  if (typeof value === 'boolean') return undefined;

  if (value === '') return undefined;

  if (!Number.isNaN(Number(value))) {
    return Number(value);
  }

  return undefined;
}
